module.exports = __webpack_public_path__ + "img/pin-on.d00f2094.svg";